import React, {useEffect, useState} from 'react'
import {PageTitle} from '../../../_metronic/layout/core'
import {Navigate, Route, Routes} from 'react-router-dom'
import {DemandListPage} from './pages/DemandListPage'
import {DemandClientCreate} from './pages/DemandClientCreate'
import {DemandeTraitement} from './pages/DemandeTraitement'
import {DispoPiece} from './pages/Televendeur/DispoPiece'
import {DetailsPiece} from './pages/Televendeur/DetailsPiece'
import {ListePieceStock} from './pages/Televendeur/ListePieceStock'
import ListePieceMarket from './pages/Televendeur/ListePieceMarket'
import {PanierProvider} from './pages/Televendeur/PanierContext'
import 'react-tooltip/dist/react-tooltip.css'
import {DemandPieceRechercher} from './pages/DemandPieceRechercher'
import {useLocation} from 'react-router'
import {useParams} from 'react-router-dom'

interface LocationState {
  clientId?: number
  demandeId?: number
  demandeImmatId?: number
  isFromClient: boolean
  isFromPOT: boolean
}

const DemandesWrapper = () => {
  const location = useLocation()
  const state = location.state as LocationState | undefined
  const [clientId, setClient] = useState<number | undefined>()
  const [demandeId, setDemandeId] = useState<number | undefined>()
  const [demandePieceId, setDemandePieceId] = useState<number | undefined>()
  const params = useParams()
  const paramsValue = params['*']

  const clientParamsId = paramsValue?.split('/')[0]

  useEffect(() => {
    setClient(state?.clientId)
    setDemandeId(state?.demandeId)
    setDemandePieceId(state?.demandeImmatId)
  }, [state])

  const demandePOTLink = {
    title: 'Pièces POT',
    path: '/pieces-pots/liste',
    isSeparator: false,
    isActive: true,
  }

  const demandeLink = {
    title: 'Demandes',
    path: '/demandes/liste',
    isSeparator: false,
    isActive: true,
  }

  const demandeFromClientLink = {
    title: 'Demandes du client',
    path: `/vente/clients/${clientId}/afficher/demandClient`,
    isSeparator: false,
    isActive: true,
  }

  const demandeTraitementLink = {
    title: 'Traitement',
    path: `/demandes/${clientId}/traitement/${demandeId}`,
    isSeparator: false,
    isActive: true,
  }

  return (
    <>
      <Routes>
        <Route
          path='/liste'
          element={
            <>
              <PageTitle
                breadcrumbs={[{title: 'Demandes', path: '#', isSeparator: false, isActive: true}]}
              >
                Liste
              </PageTitle>
              <DemandListPage />
            </>
          }
        />
        <Route
          path='/createClient'
          element={
            <>
              <DemandClientCreate />
            </>
          }
        />
        <Route
          path='/create/:clientId'
          element={
            <>
              <PageTitle breadcrumbs={[state?.isFromClient ? demandeFromClientLink : demandeLink]}>
                Création demande
              </PageTitle>
              <DemandClientCreate />
            </>
          }
        />
        <Route
          path='/:clientId/edit/:demandId'
          element={
            <>
              <PageTitle
                breadcrumbs={[
                  state?.isFromClient
                    ? {
                        title: 'Demandes du client',
                        path: `/vente/clients/${clientParamsId}/afficher/demandClient`,
                        isSeparator: false,
                        isActive: true,
                      }
                    : state?.isFromPOT
                    ? demandePOTLink
                    : demandeLink,
                ]}
              >
                Modification demande
              </PageTitle>
              <DemandClientCreate />
            </>
          }
        />
        <Route
          path='/piece/rechercher'
          element={
            <>
              <PageTitle breadcrumbs={[state?.isFromClient ? demandeLink : demandeFromClientLink]}>
                Pièces les plus recherchées
              </PageTitle>
              <DemandPieceRechercher />
            </>
          }
        />
        <Route
          path='/:clientId/traitement/:demandId'
          element={
            <PanierProvider>
              <PageTitle
                breadcrumbs={[
                  state?.isFromClient
                    ? {
                        title: 'Demandes du client',
                        path: `/vente/clients/${clientParamsId}/afficher/demandClient`,
                        isSeparator: false,
                        isActive: true,
                      }
                    : state?.isFromPOT
                    ? demandePOTLink
                    : demandeLink,
                ]}
              >
                Traitement de la demande
              </PageTitle>
              <DemandeTraitement key={demandeId}/>
            </PanierProvider>
          }
        />
        <Route
          path='/pieceDispo/:pieceId'
          element={
            <>
              <DispoPiece />
            </>
          }
        />
        <Route
          path='/:demImmat/enStock'
          element={
            <PanierProvider>
              <PageTitle breadcrumbs={[
                state?.isFromClient ? (
                  demandeFromClientLink
                ) : (
                  state?.isFromPOT ? (
                    demandePOTLink
                  ) : (
                    demandeLink
                  )
                ),
                demandeTraitementLink,
              ]} state={{state}}
              >Liste pièces en stock</PageTitle>
              <ListePieceStock key={location.pathname} />
            </PanierProvider>
          }
        />
        <Route
          path='/onMarket/:pieceId'
          element={
            <PanierProvider>
              <ListePieceMarket />
            </PanierProvider>
          }
        />
        <Route
          path='/pieceDetail/detail/:pieceStock'
          element={
            <PanierProvider>
              <PageTitle
                breadcrumbs={[
                  state?.isFromClient
                    ? demandeFromClientLink
                    : state?.isFromPOT
                    ? demandePOTLink
                    : demandeLink,
                  demandeTraitementLink,
                  {
                    title: 'Liste pièce en stock',
                    path: `/demandes/${demandeId}/enStock`,
                    isSeparator: false,
                    isActive: true,
                  },
                ]}
                state={{state}}
              >
                Détail de la pièce
              </PageTitle>
              <DetailsPiece />
            </PanierProvider>
          }
        />
        <Route index element={<Navigate to='/demandes/liste' />} />
      </Routes>
    </>
  )
}

export {DemandesWrapper}
